<template>
    <v-btn
        :block="block"
        @click="onShare"
        :color="color"
        dark
    >
        <v-icon x-small class="mr-2">fab fa-facebook-f</v-icon>
        {{ $t('Facebook') }}
    </v-btn>
</template>

<script>
export default {
    name: 'FacebookShare',
    props: {
        url: {},
        block: Boolean,
        appId: {},
    },
    data() {
        return {
            color: '#4267B2',
        };
    },
    beforeCreate() {
        if (!document.getElementById('facebookapi')) {
            let script = document.createElement('script');
            script.setAttribute('id', 'facebookapi');
            script.setAttribute('type', 'text/javascript');
            script.setAttribute('async', 'true');
            script.setAttribute('defer', 'true');
            script.setAttribute('crossorigin', 'anonymous');
            script.setAttribute('src', 'https://connect.facebook.net/en_US/sdk.js');

            let scripts = document.getElementsByTagName('script');
            scripts[scripts.length - 1].append(script);
        }
    },
    created() {
        window.fbAsyncInit = () => {
            FB.init({
                appId: this.appId,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v9.0',
            });
        };
    },
    methods: {
        onShare() {
            FB.ui(
                {
                    method: 'share',
                    href: this.url,
                },
                response => {},
            );
        },
    },
};
</script>